export enum LineItemType {
  Part = "PART",
  Service = "SERVICE",
}
